import { render } from "./SubStatusList.vue?vue&type=template&id=37a14e9e"
import script from "./SubStatusList.vue?vue&type=script&lang=js"
export * from "./SubStatusList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__